import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';
import {
  environment,
  experiment as experimentResource,
  project,
  toString as resourceSpecifierToString,
} from '@gonfalon/resource-specifiers/ast';
import {
  experimentDetail,
  getExperimentQuery,
  getExperimentsQuery,
  getInfiniteExperimentAuditLogQuery,
} from '@gonfalon/rest-api/queries/experiments';
import { layersList } from '@gonfalon/rest-api/queries/layers';

export const invalidateExperimentQueries = async ({
  projectKey,
  environmentKey,
  experimentKey,
}: {
  projectKey: string;
  environmentKey: string;
  experimentKey: string;
}) => {
  const queryClient = getQueryClient();

  // Experiment detail queries is blocking
  await queryClient.invalidateQueries({
    queryKey: getExperimentQuery.partialQueryKey({
      projectKey,
      environmentKey,
      experimentKey,
    }),
  });
  await queryClient.invalidateQueries({
    queryKey: ['EXPERIMENTS_V2', projectKey, environmentKey, experimentKey],
  });

  // Invalidate audit log queries to update discussion panel when experiment status changes
  const experimentResourceId = resourceSpecifierToString(
    experimentResource(environment(project(projectKey), environmentKey), experimentKey),
  );

  const auditSpec = [{ resources: [experimentResourceId], effect: 'allow' as const, actions: ['*'] }];
  const auditQueryKey = getInfiniteExperimentAuditLogQuery.partialQueryKey({ body: auditSpec });

  await queryClient.invalidateQueries({
    queryKey: auditQueryKey,
  });

  // Rest of the queries can happen in the background
  void Promise.all([
    queryClient.invalidateQueries({
      queryKey: getExperimentsQuery.partialQueryKey({
        projectKey,
        environmentKey,
      }),
    }),

    queryClient.invalidateQueries({
      queryKey: layersList({ projectKey }).queryKey,
    }),
    queryClient.invalidateQueries(experimentDetail({ projectKey, environmentKey, experimentKey })),
  ]);
};
